import type { LocationQuery, LocationQueryRaw } from 'vue-router';

import { UNIFIED_ROUTE_LOGIN } from '~/constants/routes/unified';

export const SIGNUP_HANDOFF_EMAIL_QUERY_PARAM = 'signup_email';

// The link's code is spent by the verify, and the invite code only locks an email field that the
// terms step does not have.
const LEFT_ON_THE_CARD = new Set(['email', 'code', 'inviteCode']);

/**
 * Where the /login card sends an email it has verified and found no account for: /login again, which
 * swaps the card for the Blinky sign-up. The verify has already put the new-role context on the
 * session, so sign-up resumes at its first new-account step with this email; everything else the
 * arrival carried (lane, entity, campaign, referral, redirect) rides along.
 */
export const buildSignupHandoffLocation = (
  query: LocationQuery,
  email: string,
): { path: string; query: LocationQueryRaw } => ({
  path: UNIFIED_ROUTE_LOGIN,
  query: {
    ...Object.fromEntries(Object.entries(query).filter(([key]) => !LEFT_ON_THE_CARD.has(key))),
    [SIGNUP_HANDOFF_EMAIL_QUERY_PARAM]: email,
  },
});

export const readSignupHandoffEmail = (query: LocationQuery): string | null => {
  const value = query[SIGNUP_HANDOFF_EMAIL_QUERY_PARAM];
  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  return value.trim();
};
